import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'company-logo-form',
  templateUrl: './company-logo-form.component.html',
  styleUrls: ['./company-logo-form.component.scss'],
})
export class CompanyLogoFormComponent {
  @Input() public logoUri: string;
  @Input() public companyId: number;
  @Output() public removeLogoSource$: EventEmitter<void> = new EventEmitter<void>();
  @Output() public uploadLogoControlSource$: EventEmitter<File> = new EventEmitter<File>();

  public isLoading: boolean = false;

  constructor() {}

  public uploadLogo(file: File): void {
    this.uploadLogoControlSource$.emit(file);
  }

  public removeLogo(): void {
    this.removeLogoSource$.emit();
  }
}
